import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'
import persist from '@alpinejs/persist'
import popup from "./popup";
import reviewSlider from "./reviewSlider";

Alpine.plugin(intersect)
Alpine.plugin(focus)
Alpine.plugin(persist)

Alpine.data('popup', popup)
Alpine.data('reviewSlider', reviewSlider)

window.Alpine = Alpine
Alpine.start()
